import { forwardRef } from 'react';
import { StyledButton } from 'shared/button/Button';
import {
    TriggeredPopup,
    TriggeredPopupProps,
} from 'shared/triggered_popup/TriggeredPopup';
import styled from 'styled-components';

const Content = styled.div`
    width: 26rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    text-align: center;
    font-size: 1.4rem;
`;

const Buttons = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    gap: 2rem;
`;

export type ConfirmActionPopupProps = Omit<TriggeredPopupProps, 'onClose'> &
    Readonly<{
        destructive?: boolean;
        noButtonLabel: string;
        yesButtonLabel: string;
        onNo: () => void;
        onYes: () => void;
        isYesDisabled?: boolean;
        isNoDisabled?: boolean;
    }>;

const ConfirmActionPopup = forwardRef<HTMLDivElement, ConfirmActionPopupProps>(
    (
        {
            children,
            destructive = false,
            noButtonLabel,
            yesButtonLabel,
            onNo,
            onYes,
            isYesDisabled,
            isNoDisabled,
            ...triggeredPopupProps
        },
        ref
    ) => (
        <TriggeredPopup ref={ref} {...triggeredPopupProps} onClose={onNo}>
            <Content>
                <div>{children}</div>
                <Buttons>
                    <StyledButton
                        type="button"
                        appearance="secondary"
                        spacing="compact"
                        onClick={onNo}
                        disabled={isNoDisabled}
                    >
                        {noButtonLabel}
                    </StyledButton>
                    <StyledButton
                        type="button"
                        onClick={onYes}
                        appearance={destructive ? 'danger' : 'primary'}
                        spacing="compact"
                        disabled={isYesDisabled}
                    >
                        {yesButtonLabel}
                    </StyledButton>
                </Buttons>
            </Content>
        </TriggeredPopup>
    )
);

export { ConfirmActionPopup };
